export class MenuAuth {
    
    static readonly FUNCTION = {
        'Home'                  :'home',
        'Company'               :"company",
        'Attendance'            :'att',
        'Claim'                 :'claim',
        'Report'                :'report',
        'Payroll'               :'payroll',
        // 'Benefit'               :'marketplace',
        'Customer'              :'sales-customer-listing',
        'Sales Order'           :'sales-salesorder-listing',
        'Purchase Requisition'  :'purchase-purchaserequisition-listing',
        'Task & Feedback'       :'task',
        'E-Learning'            :'elearning',
        'Polling'               :'survey',
        'Appraisal'             :'appraisal',
        'Activity Recording'    :'activityrecording',
        // 'Purchase Point'        :'ppob',
        // 'Budget Plan'           :'budget',
        'Payroll Process'       :'payroll-payprocess',
        'Chat'                  :'chat',
        'Make ID Card'          :'make-id-card',
        'Payslip'               :'payroll-payslip',
        'Request'               :'request-notification',
        'Overtime'              :'att-overtime',
        'Leave'                 :'att-leave',
        // 'Emergency Contact'     :'panicbutton',
        'Loan'                  :'loan',
        'Training'              :'training',
        'Transfer'              :'transfer',
        'Timesheet'             :'timesheet-request',
        'ITCS'                  :'itcs',
        // 'Survey Board'          :'company-mood-dashboard',
        // 'Employee Letter Request': 'letterrequest',
    };

    static get(key: string) : string{
        let keyAtt = MenuAuth.FUNCTION[key];        
        if(keyAtt) {
            return keyAtt;
        }
        return '';
    }
}


// WEBPACK FOOTER //
// ./src/pagebuilder/services/menu/auth.ts